export default __webpack_public_path__ + "static/media/icn_refresh_2.c4a47904.svg";